import script from "./DoctorBodySkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./DoctorBodySkeleton.vue?vue&type=script&setup=true&lang=js"

import "./DoctorBodySkeleton.vue?vue&type=style&index=0&id=c8cf2134&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8cf2134"]])

export default __exports__